import styled, { css } from 'styled-components';
import media from '../../../utils/styling/media';

export const StyledHeader = styled.div`
  display: flex;
  align-items: center;
  flex-grow: 1;
  flex-shrink: 0;
  flex-basis: 0;
  width: 100%;
  box-sizing: border-box;
  margin: 0;

  ${media.md`
    width: auto;
  `};
`;

export const StyledContentWrapper = styled.div<{
  initialized?: boolean;
  maxHeight?: string;
  display?: string;
  overflow?: string;
}>`
  ${({ initialized, maxHeight, display, overflow }) => !initialized && css`
    max-height: ${maxHeight};
    display: ${display};
    overflow: ${overflow};
  `}
`;
